<template>
    <div id="previewCert" class="app-inner">
          <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="$util.reback('/certiFicate')">
            返回
            </div>
            </div>
         <div class="certBox flex align-cen">
                <div class="certBox-item">
                    <div class="certBox-item-title">
                        {{list.title}}
                    </div>
                    <div class="certBox-item-content flex align-cen">
                        <div class="certBox-item-content-1">
                               {{list.content}}
                                     
                        </div>
                 
                    </div>
                    <div class="certBox-flex flex">
                         <div class="certBox-item-info">
                        <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">证书专业:</div>
                                <div class="top-val">
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                                Certificate Major
                            </div>
                        </div>
                         <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">证书等级:</div>
                                <div class="top-val">
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                                Certificate Level
                            </div>
                        </div>
                         <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">证书编号:</div>
                                <div class="top-val">
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                                Certificate Number
                            </div>
                        </div>
                        <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">发证机构:</div>
                                <div class="top-val top-val1">
                                    （盖章）
                                    <img :src="list.institutionSignet" alt="" class="top-val-img">
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                               Issuing Authority (Seal)
                            </div>
                        </div>
                        <div class="flex" >  
                             <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">发证日期:</div>
                                <div class="top-val">
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                              Date of Issue
                            </div>
                        </div>
                          <!-- <div class="certBox-item-info-item" style="margin-left:70px">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">发证机构负责人(签章):</div>
                                <div class="top-val2">
                                     <img :src="list.principalSignet" alt="" class="top-val-img1">
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                             Person in Charge of Issuing Authority
                            </div>
                        </div> -->
                        </div>
                         <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">查询网址:</div>
                                <div class="top-val top-val1">
                                    （盖章）
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                               Website 
                            </div>
                        </div>
                    </div>
                    <div class="mft certBox-flex-right">
                     <div class="certBox-item-content-2">
                        </div>
                        <div class="certBox-flex-right-item flex">
                            <div class="right-label">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名:</div>
                            <div class="right-val"></div>
                        </div>
                         <div class="certBox-flex-right-item flex">
                            <div class="right-label">性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别:</div>
                            <div class="right-val"></div>
                        </div>
                         <div class="certBox-flex-right-item flex">
                            <div class="right-label right-label1">出生年月:</div>
                            <div class="right-val right-val1"></div>
                        </div>
                    </div>
                    </div>
                   
                </div>
            </div>
    </div>
</template>
<script>
import {deletCertificate} from "@/api/index/index"  //证书分类、新增证书、查询证书详情
export default {
    data() {
        return {
            list:{}
        }
    },
    created () {
         this.getCertDetail()
    },
    methods: {
         // 证书详情
        getCertDetail(){
             deletCertificate({id:this.$route.query.id},'get')
            .then(res =>{
               this.list = res.data
            })
            .catch(err =>{})
        },
    },
}
</script>
<style lang="scss" scoped>
#previewCert{
    margin-bottom: 80px;
    .certBox{
        justify-content: center;
        .certBox-item{
            width:1069px;
            height: 803px;
            background: url("../../../../assets/images/certImg.jpg") no-repeat 0 0;
            background-size: 100% 100%;
            .certBox-item-title{
                text-align: center;
                font-size: 43px;
                padding-top: 128px;
                font-weight: bold;
                color: #000;
            }
            .certBox-item-content{
               padding: 0 154px;
               height: 150px;
                .certBox-item-content-1{
                    width: 100%;
                    font-size: 20px;
                    line-height: 35.3px;
                    color: #000;
                    text-indent:45px;
                    text-align: justify;
                    margin-right: 29.8px;
                     display: -webkit-box;  
                    -webkit-line-clamp: 3;  
                    -webkit-box-orient: vertical;  
                    overflow: hidden;  
                    text-overflow: ellipsis; 
                }
                .certBox-item-content-2{
                    width: 109px;
                    height: 145px;
                    background: #fff;
                }
            }
            .certBox-item-info{
                padding-left: 183px;
            .certBox-item-info-item{
                .certBox-item-info-item-top{
                    .top-label{
                        letter-spacing: 10px;
                        line-height: 28px;
                        color: #000000;
                        font-size: 16px;
                    }
                    .top-val{
                        width: 200px;
                        text-align: center;
                        font-size: 16px;
                        line-height: 28px;
                        color: #000000;
                        border-bottom: 2px solid #000;
                        position: relative;
                        .top-val-img{
                            width: 140px;
                            height: 140px;
                            border-radius: 50%;
                            position: absolute;
                            right: -50px; 
                            z-index: 999;
                        }
                       
                    }
                    .top-val2{
                        position: relative;
                          width: 100px;
                            height: 30px;
                         .top-val-img1{
                            width: 100px;
                            height: 30px;
                            position: absolute;
                        }
                    }
                    .top-val1{
                        border-bottom: none;
                        text-align: left;
                    }
                }
                .certBox-item-info-item-bot{
                     font-size: 14px;
                    line-height: 28px;
                    font-style: italic;
                }
            }
            }
            .certBox-flex-right{
                padding-right: 183px;
                 .certBox-item-content-2{
                    width: 109px;
                    height: 145px;
                    background: #fff;
                    margin: 0 auto;
                    margin-bottom: 20px;
                }
                .certBox-flex-right-item{
                    .right-label{
                        letter-spacing: 10px;
                        line-height: 35px;
                        color: #000000;
                        font-size: 16px;
                    }
                    .right-label1{
                        letter-spacing: 1px;
                    }
                    .right-val1{
                        margin-left: 8px;
                    }
                         .right-val{
                        width: 120px;
                        padding-left: 20px;
                        font-size: 16px;
                        line-height: 25px;
                        color: #000000;
                       position: relative;
                        position: relative;
                        
                    }
                    .right-val::after{
                        content:'' ;
                        position: absolute;
                        bottom: 5px;
                        left: 0;
                        width: 100%;
                        background: #000;
                         height: 2px;
                    }
                }
            }
        }
    }
}
</style>